import { CheckCircle, CheckCircleOutlineRounded } from "@mui/icons-material";
import { Card } from "@mui/material";

const ProductCard = ({ product, isActive, onClick }) => {
  return (
    Object.keys(product).length > 0 && (
      <Card
        className={isActive ? "card-Sec_active" : "card-Sec"}
        onClick={onClick}
      >
        <div className="pro_img">
          <img className="rounded" src={product.logo} alt="product_logo" />
        </div>
        <div className="pro_content">
          <div className="p_namepart">
            <div className="Care_text">{product.product_name}</div>
            {isActive ? (
              <CheckCircle className="circle_tic" />
            ) : (
              <CheckCircleOutlineRounded />
            )}
          </div>
          <div>
            <div id="pro_name">
              {/* Concatenate non-null properties of 'product' with hyphens */}
              {[
                product?.product_name,
                product?.coverType,
                product?.Policy_Type,
                product?.plan,
              ]
                .filter(Boolean)
                .join("-")}
            </div>
          </div>
          <div className="Amount">
            <div>
              <div className="Care_text">Sum Assured</div>
              <div className="Care_text">
                <b className="rupee_symp">&#8377;</b>
                {product.sumInsuredValue}
              </div>
            </div>
            <div>
              <div className="Care_text">Premium Amount</div>
              <div className="Care_text">
                <b className="rupee_symp">&#8377;</b> {product?.totalPremium || product.premium}
              </div>
            </div>
          </div>
        </div>
      </Card>
    )
  );
};

export default ProductCard;
